import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Subscription } from 'rxjs';
import { ReportingService } from '../reporting-service.service';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { SharedServicesService } from '../../../shared/sharedservices/shared-services.service';
import { ReportMainData, DeleteSavedFilterDto } from 'app/ReportingModel/ReportFiltering';

@Component({
  selector: 'app-saved-filters',
  templateUrl: './saved-filters.component.html',
  styleUrls: ['./saved-filters.component.scss']
})
export class SavedFiltersComponent implements OnInit {
  @Input() ReportMainData: ReportMainData;
  @Output() selectedTab = new EventEmitter<any>();
  tabVal: string = 'SavedReport';
  selectedTabVal: string = 'Resource'; // Default selected tab
  savedReportsSubscription: Subscription;
  savedReports: any[];
  workRequestdataSource = new MatTableDataSource();
  tabClass = "chevron_right";
  applyDiv2Class: boolean = true;
  savedReportsColumns: string[] = [
    'SavedReportName',
    'Comments',
    'SavedOn',
    'Actions'
  ];
  messageBody = '';
  messageTitle = '';
  constructor(private restService: ReportingService, private router: Router, private spinner: NgxSpinnerService,
    private restSharedService: SharedServicesService) { }

  ngOnInit(): void {
    this.getSavedReports(this.ReportMainData.reportId);
  }


  selectTabVal(tabName: string) {
    this.selectedTabVal = tabName;
  }
  ngOnDestroy() {
    if (this.savedReportsSubscription !== undefined) {
      this.savedReportsSubscription.unsubscribe();
    }
  }
  isButtonActive: boolean = false;

  toggleButton() {
    this.isButtonActive = !this.isButtonActive;
  }
  getSavedReports(reportId) {
    this.spinner.show();
    this.savedReportsSubscription =
      this.restService.GetSavedReports(reportId).subscribe(
        (data) => {
          this.savedReports = data;
          this.workRequestdataSource.data = this.savedReports;
          this.workRequestdataSource.data.forEach((element: any) => {
            // element.SavedOn = new Date(element.SavedOn);
            element.SavedOn = this.dateTimeConversion(element.SavedOn);
          });
          this.spinner.hide();
        },
        (error) => {
          console.log(error);
        },
        () => {
          this.spinner.hide();
        }
      );
  }

  tabClick(val) {
    this.tabVal = val;
  }

  OnLoadReport(SavedReportId, SavedReportName, ReportId, ReportCode, ReportName, SavedReportFilterParameters) {
    this.ReportMainData = new ReportMainData();
    this.ReportMainData.reportId = ReportId;
    this.ReportMainData.reportName = ReportName;
    this.ReportMainData.reportCode = ReportCode;
    this.ReportMainData.savedReportId = SavedReportId;
    this.ReportMainData.savedReportName = SavedReportName;
    this.ReportMainData.savedReportFilterParameters = SavedReportFilterParameters;
    this.restSharedService.emitSavedReportDetailsEvent(this.ReportMainData);
  }


  changeStyle($event) {
    this.tabClass = $event.type == 'mouseover' ? 'divCell-hover' : 'divCell';
  }


  private dateTimeConversion(inputDateString): string {

    const parsedDate = new Date(inputDateString);

    // const daysOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    //const dayOfWeek = daysOfWeek[parsedDate.getDay()];
    const month = months[parsedDate.getMonth()];
    const day = parsedDate.getDate();
    const year = parsedDate.getFullYear();

    const hours = parsedDate.getHours();
    const minutes = parsedDate.getMinutes();
    const seconds = parsedDate.getSeconds();

    // Determine if it's AM or PM and convert hours to 12-hour format
    const period = hours >= 12 ? 'PM' : 'AM';
    const twelveHourFormatHours = hours % 12 || 12; // Convert 0 to 12 for midnight

    // Construct the formatted date string
    const formattedDate = `${day} ${month}, ${year}`;

    // Construct the formatted time string in 12-hour clock format
    //const formattedTime = `${twelveHourFormatHours}:${padZero(minutes)}:${padZero(seconds)} ${period}`;
    const formattedTime = `${twelveHourFormatHours}:${padZero(minutes)}:${period}`;

    function padZero(num) {
      return num < 10 ? `0${num}` : `${num}`;
    }

    const formattedDateTime = `${formattedDate} | ${formattedTime}`;

    return formattedDateTime;

  }

  DeleteFilter(SavedReportId) {
    this.spinner.show();
    let model = new DeleteSavedFilterDto();
    model.savedReportId = SavedReportId;
    this.restService.deleteSavedReport(model).subscribe(response => {
      if (response.customResultId <= 0) {
        console.error('Error saving delete ', response.customException);
        this.messageTitle = 'Failed';
        this.messageBody = response.customException;
        this.onScroll();
      }
      else {
        console.log('Saved report deleted successfully', response);
        this.messageTitle = 'Success';
        this.messageBody = "Saved report deleted successfully.";
        this.onScroll();
      }
    }, error => {
      console.error('Error saving data', error);
      this.messageTitle = 'Failed';
      this.messageBody = "Unexpected server error. Please try again.";
      this.onScroll();
    }, () => {
      this.getSavedReports(this.ReportMainData.reportId);
    });
  }
  onScroll() {
    this.restService.triggerNavigateToReportparent();
  }
  closeMessage() {
    this.messageBody = '';
    this.messageTitle = '';
  }
}
